import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { keys } from '@/api/queryKeys';
import { AppConfig } from '@/context/AppConfig';
import { AppRequests } from '@/context/AppRequests';
import { BPReward } from './types';

export const useRewards = () => {
  const { getRewardsRequest } = useContext(AppRequests).RewardsRequests;
  const { logError } = useContext(AppConfig);

  const result = useQuery({
    queryKey: [keys.REWARDS],
    queryFn: getRewardsRequest,
    onError: (error) => {
      logError('Error fetching notes', error as Error);
    },
  });

  return { ...result };
};

export const rewardCategories = (rewards: BPReward[]) => {
  if (!rewards) return [];

  const categories = rewards
    ?.flatMap((reward: BPReward) => reward.tags)
    .filter((tag, index, self) => self.indexOf(tag) === index)
    .sort() as string[];

  if (categories && categories.length > 0) categories.unshift('All');
  return categories;
};

export const filterRewards = (category: string, rewards: BPReward[]) => {
  if (category !== 'All') {
    return rewards.filter((reward: BPReward) =>
      reward.tags?.flat().includes(category)
    );
  }
  return rewards;
};
